module.exports = __webpack_public_path__ + "img/PL00275.581da570.png";